module.exports = __webpack_public_path__ + "static/media/ic_categories_instrument.2fee062a.svg";